/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Gender/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Gender({
  children,
  viewPath = "/DesignSystem/SyncPatientMatchingCard/Gender"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let cardPatientGenderValueData = fromData.useDataValue({ viewPath,
context: 'card',
path: 'patient.gender',
})
let cardMatchGenderValueData = fromData.useDataValue({ viewPath,
context: 'card',
path: 'match.gender',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsRed900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.900'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<div
  data-testid="Gender.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-2vM3t4': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 color={!cardMatchGenderValueData ? dtColorsRed900 : dtColorsNeutral900}
 data="card.patient.gender"
 text={cardPatientGenderValueData}
 data="card.match.gender"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral400}
 text="•"
/>
</div>
{children}
</React.Fragment>)
}